<template>
  <section class="tarifResaView">
    <div class="giteContainer tarifsSection">
      <h2 class="titlePage">
        <strong>_</strong>
        Tarifs
        <!-- {{ new Date().getFullYear() }} -->
        <strong>_</strong>
      </h2>
      <br>
      <ul class="summary">
        <li class="summary-item sommaire">
          <p>SOMMAIRE</p>
        </li>
        <li class="summary-item">
          <a href="#six">
            <p class="rond">Gite 6 personnes</p>
          </a>
        </li>
        <li class="summary-item">
          <a href="#huit">
            <p class="rond">Gite 8 personnes </p>
          </a>
        </li>
        <li class="summary-item">
          <a href="#quinze">
            <p class="rond">Gite 15 personnes</p>
          </a>
        </li>
        <li class="summary-item">
          <a href="#extrat">
            <p class="rond">Les extras </p>
          </a>
        </li>
      </ul>
      <br>

      <h3 id="six">Gite 6 personnes : </h3>
      <div class="scrollX">
        <table>
          <tr>
            <th>
            </th>
            <th class="saison">
              Basse saison <br>
              <span><b>Location à partir de 2 nuits</b> </span> <br>
              <span>Du 8 janvier au 5 avril </span> <br>
              <span>Du 21 septembre au 18 octobre </span> <br>
              <span>Du 4 novembre au 20 décembre</span>
            </th>
            <th class="saison">
              Moyenne saison<br>
              <span><b>Location à partir de 2 nuits</b> </span> <br>
              <span>Du 6 avril au 21 juin </span> <br>
              <span>Du 31 août au 20 septembre </span> <br>
              <span>Du 19 octobre au 3 novembre </span> <br>
              <span> Du 21 décembre au 5 janvier </span>
            </th>
            <th class="saison">
              Avant saison<br>
              <span><b>Location à partir de 5 nuits</b> </span> <br>
              <span>Du 22 juin au 5 juillet </span>
            </th>
            <th class="saison">
              Haute saison<br>
              <span><b>Location à partir de 5 nuits</b> </span> <br>
              <span>Du 6 juillet au 30 août </span>
            </th>
          </tr>
          <tr>
            <td>2 nuits</td>
            <td>400 €</td>
            <td>440 €</td>
            <td>320 €</td>
            <td>480 €</td>
          </tr>

          <tr>
            <td>3 nuits</td>
            <td>465 €</td>
            <td>570 €</td>
            <td>420 €</td>
            <td>630 €</td>
          </tr>

          <tr>
            <td>4 nuits</td>
            <td>550 €</td>
            <td>680 €</td>
            <td>500 €</td>
            <td>792 €</td>
          </tr>

          <tr>
            <td>5 nuits</td>
            <td>640 €</td>
            <td>800 €</td>
            <td>575 €</td>
            <td>930 €</td>
          </tr>

          <tr>
            <td>6 nuits</td>
            <td>640 €</td>
            <td>890 €</td>
            <td>600 €</td>
            <td>1030 €</td>
          </tr>

          <tr>
            <td>7 nuits</td>
            <td>700 €</td>
            <td>895 €</td>
            <td>665 €</td>
            <td>1050 €</td>
          </tr>

          <tr>
            <td>Information <br> complémentaire : </td>
            <td>
              Arrivée et départ tous les jours possibles
            </td>
            <td>
              Arrivée et départ tous les jours possibles
            </td>
            <td>
              Arrivée et départ tous les jours possibles <br>
              A J-60, location à partir de 2 nuits <br>
            </td>
            <td>
              Arrivée et départ tous les jours possibles <br>
              A J-60, location à partir de 2 nuits <br>
            </td>
          </tr>

          <!-- <tr>
            <td>Draps</td>
            <td>Inclus</td>
            <td>Inclus</td>
            <td>Inclus</td>
            <td>Inclus</td>
          </tr>

          <tr>
            <td>Linge de toilette</td>
            <td>Inclus</td>
            <td>Inclus</td>
            <td>Inclus</td>
            <td>Inclus</td>
          </tr>

          <tr>
            <td>Chauffage</td>
            <td>25 € / jours</td>
            <td>25 € / jours</td>
            <td>25 € / jours</td>
            <td>25 € / jours</td>
          </tr>

          <tr>
            <td>Ménage (obligatoire)</td>
            <td>300 €</td>
            <td>300 €</td>
            <td>300 €</td>
            <td>300 €</td>
          </tr>

          <tr>
            <td>Caution</td>
            <td>2000 €</td>
            <td>2000 €</td>
            <td>2000 €</td>
            <td>2000 €</td>
          </tr>

           <tr>
            <td>Taxe de séjour</td>
            <td>1.20 € / adulte / jour</td>
            <td>1.20 € / adulte / jour</td>
            <td>1.20 € / adulte / jour</td>
            <td>1.20 € / adulte / jour</td>
           </tr> -->
        </table>
      </div>
      <br>
      <h3 id="huit">Gite 8 personnes : </h3>
      <div class="scrollX">
        <table>
          <tr>
            <th>
            </th>
            <th class="saison">
              Basse saison <br>
              <span><b>Location à partir de 2 nuits</b> </span> <br>
              <span>Du 8 janvier au 5 avril </span> <br>
              <span>Du 21 septembre au 18 octobre </span> <br>
              <span>Du 4 novembre au 20 décembre</span>
            </th>
            <th class="saison">
              Moyenne saison<br>
              <span><b>Location à partir de 2 nuits</b> </span> <br>
              <span>Du 6 avril au 21 juin </span> <br>
              <span>Du 31 août au 20 septembre </span> <br>
              <span>Du 19 octobre au 3 novembre </span> <br>
              <span> Du 21 décembre au 5 janvier </span>
            </th>
            <th class="saison">
              Avant saison<br>
              <span><b>Location à partir de 5 nuits</b> </span> <br>
              <span>Du 22 juin au 5 juillet </span>
            </th>
            <th class="saison">
              Haute saison<br>
              <span><b>Location à partir de 5 nuits</b> </span> <br>
              <span>Du 6 juillet au 30 août </span>
            </th>
          </tr>
          <tr>
            <td>2 nuits</td>
            <td>980 €</td>
            <td>980 €</td>
            <td>1200 €</td>
            <td>1300 €</td>
          </tr>

          <tr>
            <td>3 nuits</td>
            <td>1200 €</td>
            <td>1200 €</td>
            <td>1410 €</td>
            <td>1500 €</td>
          </tr>

          <tr>
            <td>4 nuits</td>
            <td>1400 €</td>
            <td>1520 €</td>
            <td>1940 €</td>
            <td>1880 €</td>
          </tr>

          <tr>
            <td>5 nuits</td>
            <td>1600 €</td>
            <td>1750 €</td>
            <td>2100 €</td>
            <td>2300 €</td>
          </tr>

          <tr>
            <td>6 nuits</td>
            <td>1800 €</td>
            <td>1920 €</td>
            <td>2280 €</td>
            <td>2580 €</td>
          </tr>

          <tr>
            <td>7 nuits</td>
            <td>1750 €</td>
            <td>1960 €</td>
            <td>2450 €</td>
            <td>2940 €</td>
          </tr>

          <tr>
            <td>Information <br> complémentaire : </td>
            <td>
              Arrivée et départ tous les jours possibles
            </td>
            <td>
              Arrivée et départ tous les jours possibles
            </td>
            <td>
              Arrivée et départ tous les jours possibles <br>
              A J-60, location à partir de 2 nuits <br>
            </td>
            <td>
              Arrivée et départ tous les jours possibles <br>
              A J-60, location à partir de 2 nuits <br>
            </td>
          </tr>

          <!-- <tr>
            <td>Ménage en fin de séjour</td>
            <td>300 €</td>
          </tr> -->

          <!-- <tr>
            <td>Linge de toilette</td>
            <td>Inclus</td>
          </tr> -->

          <!-- <tr>
            <td>Chauffage électricité</td>
            <td>25 € / jour</td>
          </tr> -->

          <!-- <tr>
            <td>Bois</td>
            <td>50 € / stère</td>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->

          <!-- <tr>
            <td>Caution</td>
            <td>2000€</td>
          </tr> -->

          <!-- <tr>
            <td>Location salle</td>
            <td>200 €</td>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->
          <!-- <tr>
            <td>Taxe de séjour</td>
            <td>1.20 € / adulte / jour</td>
          </tr> -->
        </table>
      </div>
      <br>
      <h3 id="quinze">Gite 15 personnes : </h3>
      <div class="scrollX">
        <table>
          <tr>
            <th>
            </th>
            <th class="saison">
              Basse saison <br>
              <span><b>Location à partir de 2 nuits</b> </span> <br>
              <span>Du 8 janvier au 5 avril </span> <br>
              <span>Du 21 septembre au 18 octobre </span> <br>
              <span>Du 4 novembre au 20 décembre</span>
            </th>
            <th class="saison">
              Moyenne saison<br>
              <span><b>Location à partir de 2 nuits</b> </span> <br>
              <span>Du 6 avril au 21 juin </span> <br>
              <span>Du 31 août au 20 septembre </span> <br>
              <span>Du 19 octobre au 3 novembre </span> <br>
              <span> Du 21 décembre au 5 janvier </span>
            </th>
            <th class="saison">
              Avant saison<br>
              <span><b>Location à partir de 2 nuits</b> </span> <br>
              <span>Du 22 juin au 5 juillet </span>
            </th>
            <th class="saison">
              Haute saison<br>
              <span><b>Location à partir de 5 nuits</b> </span> <br>
              <span>Du 6 juillet au 30 août </span>
            </th>
          </tr>
          <tr>
            <td>2 nuits</td>
            <td>1300 €</td>
            <td>1300 €</td>
            <td>1300 €</td>
            <td>X</td>
          </tr>

          <tr>
            <td>3 nuits</td>
            <td>1400 €</td>
            <td>1400 €</td>
            <td>1400 €</td>
            <td>X</td>
          </tr>

          <tr>
            <td>4 nuits</td>
            <td>1930 €</td>
            <td>1930 €</td>
            <td>1930 €</td>
            <td>X</td>
          </tr>

          <tr>
            <td>5 nuits</td>
            <td>2000 €</td>
            <td>2000 €</td>
            <td>2000 €</td>
            <td>3000 €</td>
          </tr>

          <tr>
            <td>6 nuits</td>
            <td>2200 €</td>
            <td>2200 €</td>
            <td>2500 €</td>
            <td>3000 €</td>
          </tr>

          <tr>
            <td>7 nuits</td>
            <td>2000 €</td>
            <td>2200 €</td>
            <td>2500 €</td>
            <td>3000 €</td>
          </tr>

          <tr>
            <td>Information <br> complémentaire : </td>
            <td>
              Arrivée et départ <br> tous les jours possibles
            </td>
            <td>
              Arrivée et départ <br> tous les jours possibles
            </td>
            <td>
              Arrivée et départ <br> tous les jours possibles <br>
            </td>
            <td>
              Arrivée et départ <br> tous les jours possibles <br>

            </td>
          </tr>

          <!-- <tr>
            <td>Ménage en fin de séjour</td>
            <td>300 €</td>
          </tr> -->

          <!-- <tr>
            <td>Linge de toilette</td>
            <td>Inclus</td>
          </tr> -->

          <!-- <tr>
            <td>Chauffage électricité</td>
            <td>25 € / jour</td>
          </tr> -->

          <!-- <tr>
            <td>Bois</td>
            <td>50 € / stère</td>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->

          <!-- <tr>
            <td>Caution</td>
            <td>2000€</td>
          </tr> -->

          <!-- <tr>
            <td>Location salle</td>
            <td>200 €</td>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->
          <!-- <tr>
            <td>Taxe de séjour</td>
            <td>1.20 € / adulte / jour</td>
          </tr> -->
        </table>
      </div>
      <h3 id="extrat">Les extras </h3>
      <div class="scrollX">
        <table>
          <tr>
            <th class="saison" colspan="2">
              Pour tous nos hebergements <br>
            </th>
          </tr>
          <tr>
            <td>Draps</td>
            <td>Inclus</td>
          </tr>

          <tr>
            <td>Linge de toilette</td>
            <td>Inclus</td>
          </tr>

          <tr>
            <td>Ménage <br>
              <span> (obligatoire)</span>
            </td>
            <td>300 €</td>

          </tr>

          <tr>
            <td>Chauffage</td>
            <td>25€/jour</td>
          </tr>

          <tr>
            <td>Caution</td>
            <td>2000 €</td>

          </tr>

          <tr>
            <td>Taxe de séjour</td>
            <td>En sus 1,20 € / pers/ nuitée</td>
          </tr>
        </table>
      </div>
      <br>
    </div>

    <section class="BtnDispoBox">
      <div class="box-btn">
        <a href="/reservations-studio" class="greenBtn">Voir les disponibilités du petit gite</a>
        <a href="/reservations-gite" class="greenBtn">Voir les disponibilités du grand gite</a>
      </div>
    </section>


    <Slideshow sliderheight="450px" :slidewidth="responsiveWidth" rightnav_class="fas fa-angle-right fa-4x"
      leftnav_class="fas fa-angle-left fa-4x" activeclass="activeDiapo">
      <div>
        <img src="@/assets/images/001.png" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/002.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/003.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/004.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/005.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/006.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/007.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/008.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/009.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/010.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/011.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/013.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/014.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/015.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/016.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/017.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/018.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/019.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/020.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/021.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/022.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/023.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/024.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/025.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/026.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/027.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/029.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/030.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/031.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/032.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/033.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/034.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/035.jpg" alt="Gite d'en lebé" />
      </div>

      <div>
        <img src="@/assets/images/037.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/038.jpg" alt="Gite d'en lebé" />
      </div>
    </Slideshow>

    <div class="barBottom">
      <div class="navImg">
        <router-link to="/contact">
          <img src="@/assets/icones/map.png" alt="icone carte" />
          <p>
            <strong>Nous trouver</strong>
            <br />
            {{ $store.state.globalData.name }}
            {{ $store.state.globalData.ville }}
          </p>
        </router-link>
        <a href="tel:0625627464">
          <!-- <img src="@/assets/icones/clef.png" alt="icone jeu de clefs" /> -->
          <i class="fab fa-whatsapp"></i>
          <p>
            <strong>Réservation</strong>
            <br />
            {{ $store.state.globalData.bandeauVertTel }}
            <p>(Sms & appels)</p>
          </p>
        </a>
        <a href="mailto:enlebegite@gmail.com">
          <i class="fal fa-envelope fa-2x"></i>
          <p>
            <strong>{{ $store.state.globalData.emailBandeauVert }}</strong>
            <br />
            <!-- {{ $store.state.globalData.telephonePortable }} -->
          </p>
        </a>
      </div>
    </div>
    <button id="scrollToTopButton" style="display: none;"><i class="fas fa-arrow-up"></i></button>
  </section>
</template>

<script>
import Slideshow from "@/components/Slideshow.vue";

export default {
  name: "TarifsResa",
  components: { Slideshow },
  computed: {
    responsiveWidth: {
      get() {
        let val = window.innerWidth;
        if (val > 1000) {
          return "25";
        } else if (val < 1000 && val > 768) {
          return "50";
        } else return "90";
      },
    },
  },
  mounted() {
    const headerHeight = 190;

    document.querySelectorAll('.summary-item a').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        let target = this.getAttribute('href');
        let targetElement = document.querySelector(target);

        if (targetElement) {
          let targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: targetPosition - headerHeight,
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
    $(window).scroll(function () {
      var scrollPosition = $(window).scrollTop();
      console.log(scrollPosition);
      if (scrollPosition > 100) {
        $(".summary").addClass("scrolled");
      } else {
        $(".summary").removeClass("scrolled");
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      const scrollBtn = document.getElementById('scrollToTopButton');

      // Fonction pour détecter le défilement et afficher/masquer le bouton
      function scrollFunction() {
        if (document.body.scrollTop > window.innerHeight / 2 || document.documentElement.scrollTop > window.innerHeight / 2) {
          scrollBtn.style.display = "block";
        } else {
          scrollBtn.style.display = "none";
        }
      }

      // Écouter l'événement de défilement
      window.onscroll = function () {
        scrollFunction();
      };

      // Fonction pour le retour en haut de la page
      scrollBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

  },
};
</script>
<style>
table {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  margin-bottom: 2rem;
}

tr:nth-child(even) {
  background: #fff;
}

th,
tr:nth-child(odd) {
  background: rgb(228, 236, 218);
}

th,
td {
  padding: 1rem 0;
}

.tarifResaView .imageContainer>*>* {
  /* object-fit: contain;
  background: rgb(228, 236, 218); */
}

.tarifResaView .slideBtn {
  color: white;
}

.tarifsSection {
  text-align: center;
}

.tarifsSection h2 {
  margin: 0 0 2rem;
}

.activeDiapo {}

.tarifResaView .imageContainer>* {
  padding: 5px;
}

.BtnDispoBox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
}

.box-btn {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.saison span {
  font-size: 13px;
  font-weight: 500;
}

.summary {
  display: flex;
  margin: 0;
  padding: 0;
  text-align: center;
  list-style: none;
  background-color: #A8BE50;
  border: 1px solid #A8BE50;
  color: white;
}

.summary li {
  flex: 1;
  transition: .4s all;
  flex-wrap: wrap;
}

.summary li a {
  transition: .4s all;
  color: white;
}

.summary li:hover a {
  color: #A8BE50;
}

.summary li:hover {
  background-color: white;
  color: #A8BE50;
}

.summary-item {
  border-right: 1px solid #000;
}

/* Style pour le dernier élément de liste pour supprimer la bordure du bas */
.summary-item:last-child {
  border-right: none;
}

.summary.scrolled {
  position: fixed;
  top: 155px;
  left: 0;
  right: 0;
  margin: 0rem 13vw;
  height: 80px;
  z-index: 1;
}

#scrollToTopButton {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  padding: 20px;
  background-color: #A8BE50;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #A8BE50;
  transition: 0.4s;
}

#scrollToTopButton:hover {
  background-color: white;
  border: 1px solid #A8BE50;
}

#scrollToTopButton:hover i {
  color: #A8BE50;
}

@media all and (max-width: 768px) {
  .tarifsSection {
    overflow-x: scroll;
  }

  table {
    min-width: 700px;
  }

  .summary {
    flex-direction: column;
  }
}
</style>


